import PricingView from "./PricingView";
import { Landing } from "components";

export const PricingContainer = () => {
  return (
    <Landing>
      <PricingView />
    </Landing>
  );
};
